import type { LocaleOption } from '@wehunt/ui'

/**
 * The languages the top bar's picker offers: the seven this app ships, by
 * endonym, on the flags wehunt.app's own picker uses. Norwegian is the macro
 * code `no` because that is where the locale bundles live — `nb`/`nn` are
 * accepted on the way in (see `pickerLanguage`) but resolve to the same
 * resources.
 *
 * Kept as data rather than reusing the settings page's list because that one
 * has no flags, and the two pickers may legitimately diverge (the bar could
 * one day offer a market as well).
 */
export const TOP_BAR_LANGUAGES: LocaleOption[] = [
  { id: 'en', label: 'English', flag: 'GB' },
  { id: 'sv', label: 'Svenska', flag: 'SE' },
  { id: 'fi', label: 'Suomi', flag: 'FI' },
  { id: 'no', label: 'Norsk', flag: 'NO' },
  { id: 'da', label: 'Dansk', flag: 'DK' },
  { id: 'de', label: 'Deutsch', flag: 'DE' },
  { id: 'fr', label: 'Français', flag: 'FR' },
]

const PICKER_IDS = new Set(TOP_BAR_LANGUAGES.map((l) => l.id))

/**
 * The picker row that stands for the app's current language. i18next may
 * report a regional tag (`sv-SE`) or a Norwegian variant (`nb`, `nn-NO`); the
 * picker knows only the seven base codes. Anything it cannot place shows as
 * English, which is also what the app falls back to.
 */
export function pickerLanguage(language: string | undefined): string {
  const base = (language ?? '').toLowerCase().split(/[-_]/)[0]
  if (base === 'nb' || base === 'nn') return 'no'
  return PICKER_IDS.has(base) ? base : 'en'
}

export function isPickerLanguage(id: string): boolean {
  return PICKER_IDS.has(id)
}
